import { useStyles } from '@team-griffin/stylr';
import getBreakpoints from 'presentation/utils/getBreakpoints';
import { Layout } from 'domain/constants/layout';
import { BreakpointProps } from '@ux/responsive';

import { getActiveAnchor } from '../styles';

export default (
  props: {
    layout: Layout;
  } & BreakpointProps,
) => {
  const { layout } = props;
  const { anchor } = layout;
  const breakpointProps = getBreakpoints(props);
  // @ts-ignore: error after upgrading to ux-configs
  const activeAnchor = getActiveAnchor(anchor, breakpointProps);
  return useStyles(
    {
      default: {
        content: {
          flex: 1,
          flexBasis: 'auto',
          justifyContent: activeAnchor,
          display: 'flex',
          flexDirection: 'column',
        },
      },
    },
    [{ activeAnchor }],
  );
};
